import {getAuthenticatedThemisClient, TaskView} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'
import {createSelector} from 'reselect'
import {TaskCategory, TaskStatus} from '@modifi/enums'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/tasks',
  reducerPath: ['data', 'tasks'],
  fetchRequest: () =>
    apiClient?.Tasks?.fetch({
      'filter.status': [TaskStatus.TODO, TaskStatus.IN_REVIEW],
      orderBy: ['dueDateOn'],
      orderDirection: ['DESC'],
    }).then(res => res.data()?.tasks || []),
})

export default reducer

export const selectAllTasks = (state: Record<string, any>): TaskView[] =>
  (selectors.selectEntity(state) || []) as unknown as TaskView[]

export const aFetchTasks = (): AppThunkAction => actions.fetch()

export const selectTasksByCategory = createSelector(
  selectAllTasks,
  (state: Record<string, any>, category: string) => category,
  (allTasks, category) => allTasks?.filter(task => task?.category === category)
)

export const selectTasksForBSRByTaskCategory = createSelector(
  selectTasksByCategory,
  (
    state: Record<string, any>,
    taskCategory: keyof typeof TaskCategory,
    externalTradePartnerId: string
  ) => externalTradePartnerId,
  (tasks, externalTradePartnerId): TaskView | undefined =>
    tasks.find(
      task => !!task.relatedEntities?.find(entity => entity.key === externalTradePartnerId)
    )
)
